import { render } from "./ListCard.vue?vue&type=template&id=c964f10e"
import script from "./ListCard.vue?vue&type=script&lang=js"
export * from "./ListCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__